import React from "react";
import { Upload, Sparkles, Cog, Truck } from "lucide-react";
import Reveal from "@/components/Reveal";

const STEPS = [
  {
    id: 1,
    icon: Upload,
    title: "Send your files",
    desc: "Drop your STL, STEP, OBJ or even a rough sketch on WhatsApp. Not sure what to send? Ask the AI Assistant.",
    time: "0 min",
  },
  {
    id: 2,
    icon: Sparkles,
    title: "We review + quote",
    desc: "We DFM-check the mesh, pick the ideal material & orientation, and reply with a fixed all-in quote.",
    time: "under 4 hrs",
  },
  {
    id: 3,
    icon: Cog,
    title: "Print + finish",
    desc: "We pick the ideal FDM or resin process, layer height and infill for your part. Sanding, priming and paint on request.",
    time: "24–72 hrs",
  },
  {
    id: 4,
    icon: Truck,
    title: "Delivered in BLR",
    desc: "Pickup from the Gunjur studio or courier across Bengaluru. Pan-India shipping via Delhivery on request.",
    time: "typically 1–2 days",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-16 items-end">
          <div className="lg:col-span-6">
            <Reveal>
              <span className="label-overline">/ 02 — How it works</span>
              <h2 className="font-display text-4xl sm:text-5xl mt-6 leading-[1.05] font-semibold tracking-tight">
                Sketch on Monday.<br />
                <span className="text-[#FF5722]">Hold it on Wednesday.</span>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <Reveal delay={120}>
              <p className="text-zinc-400 leading-relaxed">
                Four steps, one WhatsApp number. No forms, no NDAs to chase — just
                a fast, transparent hand-off from file to finished part.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {STEPS.map((s, idx) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.id} delay={idx * 100}>
                <div
                  data-testid={`process-step-${s.id}`}
                  className="group relative bg-[#0A0A0C] p-7 h-full hover:bg-[#111114] transition-colors"
                >
                  <div className="flex items-center justify-between mb-8">
                    <span className="font-display text-6xl text-white/5 group-hover:text-[#FF5722]/20 transition-colors">
                      0{s.id}
                    </span>
                    <span className="w-11 h-11 grid place-items-center border border-white/15 group-hover:border-[#FF5722] group-hover:rotate-6 transition-all duration-500">
                      <Icon size={18} className="text-[#FF5722]" />
                    </span>
                  </div>
                  <h3 className="font-display text-xl mb-3">{s.title}</h3>
                  <p className="text-zinc-400 text-sm leading-relaxed mb-6">
                    {s.desc}
                  </p>
                  <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 pt-4 border-t border-white/5">
                    <span>Timing</span>
                    <span className="text-white">{s.time}</span>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
